module.exports = __webpack_public_path__ + "img/ifs-logo.0334561f.png";